import React, { Fragment } from 'react';
import { Field } from 'redux-form';
import {
  Button,
  Divider,
  Form,
  Grid,
  Icon,
  Accordion,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { TitledCard } from 'Components';
import { DropdownField } from 'Common/SemanticWrapper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { TRUCK_ROUTE_REPORT_FORM_NAME } from 'Common/FormEnum';
import { TruckRouteReportEnum } from 'Common/FieldEnum';
import SelectSitesTable from 'Common/SelectSitesTable';

import { groupByOptions, weekDayOptions } from './../helper/index';

const TruckRouteReportComponent = props => {
  const {
    setGroupByOption,
    groupByOptionsValue,
    clearFilters,
    setSelectedSites,
    getSitesCallback,
    activeIndexForFilter,
    handleClick,
    reactTableRef,
  } = props;

  return (
    <Fragment>
      <Form>
        <Accordion fluid styled>
          <Accordion.Title
            active={!activeIndexForFilter}
            index={0}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Filter By</span>
          </Accordion.Title>
          <Accordion.Content active={!activeIndexForFilter}>
            <Grid className="grid-spacing">
              <Grid.Row>
                <Grid.Column width={13}>
                  <Field
                    options={weekDayOptions}
                    placeholder="Select Day"
                    search
                    selection
                    fluid
                    multiple
                    component={DropdownField}
                    label={'Day(s)'}
                    name={TruckRouteReportEnum.DayOfWeek}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={13}>
                  <TitledCard title={'Group By'}>
                    <ReduxFormButtonGroup
                      options={groupByOptions}
                      value={groupByOptionsValue}
                      formName={TRUCK_ROUTE_REPORT_FORM_NAME}
                      fieldName={TruckRouteReportEnum.GroupByOptions}
                      onChange={setGroupByOption}
                      type={'button'}
                    />
                  </TitledCard>
                </Grid.Column>
                <Grid.Column
                  width={3}
                  textAlign={'right'}
                  style={{ marginTop: '45px' }}
                  floated={'right'}
                >
                  <Button
                    className={'clear-filters-button'}
                    content="Clear Filters"
                    onClick={clearFilters}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>
        <Divider horizontal />
        <Accordion fluid styled>
          <Accordion.Content active={!activeIndexForFilter}>
            <SelectSitesTable
              onChange={setSelectedSites}
              getSitesCallback={getSitesCallback}
              isActive={true}
              isLicensed={false}
              showPageSizeOptions={true}
              defaultPageSize={20}
              filterable={true}
              sortable={true}
              tableProps={{ ref: reactTableRef }}
            />
          </Accordion.Content>
        </Accordion>
      </Form>
    </Fragment>
  );
};

TruckRouteReportComponent.propTypes = {
  setGroupByOption: PropTypes.func,
  clearFilters: PropTypes.func,
  setSelectedSites: PropTypes.func,
  getSitesCallback: PropTypes.func,
  handleClick: PropTypes.func,
  reactTableRef: PropTypes.object,
  groupByOptionsValue: PropTypes.number,
  activeIndexForFilter: PropTypes.number,
};

TruckRouteReportComponent.defaultProps = {
  setGroupByOption: () => {},
  clearFilters: () => {},
  setSelectedSites: () => {},
  getSitesCallback: () => {},
  reactTableRef: null,
  groupByOptionsValue: 0,
  activeIndexForFilter: 0,
};

export default TruckRouteReportComponent;



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/truckroutereport/components/TruckRouteReport.js